const courses = [
  {
    id: 1,
    title: 'Curso de Teologia',
    description: '14 módulos de estudos completos, com apostilas e PDFs, aulas expositivas e presenciais. Formação teológica sólida e abrangente.',
    duration: '14 Módulos',
    modality: 'Presencial e Online',
    icon: 'ri-book-2-line',
    features: ['Apostilas Completas', 'Certificação', 'Aulas Expositivas'],
    image: 'https://public.readdy.ai/ai/img_res/c60ef16958446436157193f396fe301e.jpg'
  },
  {
    id: 2,
    title: 'Curso de Capelania Cristã',
    description: 'Capacitação completa para ministério de capelania hospitalar e assistência espiritual, com e-book e mentoria personalizada.',
    duration: 'Programa Completo',
    modality: 'Presencial e Online',
    icon: 'ri-heart-pulse-line',
    features: ['E-book Incluído', 'Certificação', 'Mentoria'],
    image: 'https://readdy.ai/api/search-image?query=Christian%20chaplain%20caring%20for%20patient%2C%20hospital%20chapel%20with%20soft%20natural%20light%2C%20bible%20and%20prayer%20book%20on%20bedside%2C%20compassionate%20spiritual%20care%20scene%2C%20peaceful%20healing%20atmosphere%20with%20simple%20background&width=600&height=400&seq=icmi-course-chaplaincy-001&orientation=landscape'
  },
  {
    id: 3,
    title: 'Curso de Liderança',
    description: 'Líderes não nascem prontos! Desenvolva suas habilidades de liderança cristã com apostila completa e aulas expositivas.',
    duration: 'Formação Intensiva',
    modality: 'Presencial e Online',
    icon: 'ri-team-line',
    features: ['Apostila Completa', 'Certificação', 'Aulas Práticas'],
    image: 'https://readdy.ai/api/search-image?query=Christian%20leadership%20training%20with%20diverse%20group%20of%20church%20leaders%20in%20discussion%2C%20professional%20ministry%20environment%2C%20inspirational%20workspace%20with%20bibles%20and%20leadership%20books%2C%20collaborative%20learning%20atmosphere%20with%20simple%20clean%20background&width=600&height=400&seq=icmi-course-leadership-001&orientation=landscape'
  },
  {
    id: 4,
    title: 'Curso de Pregação Expositiva',
    description: 'Aprenda técnicas de pregação expositiva bíblica com e-book completo e mentoria para desenvolver suas habilidades no púlpito.',
    duration: 'Programa Completo',
    modality: 'Presencial e Online',
    icon: 'ri-user-voice-line',
    features: ['E-book Incluído', 'Certificação', 'Mentoria'],
    image: 'https://readdy.ai/api/search-image?query=Pastor%20preaching%20from%20pulpit%20with%20open%20bible%2C%20church%20setting%20with%20soft%20warm%20lighting%2C%20inspirational%20speaking%20scene%2C%20wooden%20podium%20with%20cross%2C%20peaceful%20worship%20atmosphere%20with%20simple%20background%20emphasizing%20biblical%20exposition&width=600&height=400&seq=icmi-course-preaching-001&orientation=landscape'
  },
  {
    id: 5,
    title: 'Curso de Aconselhamento Pastoral',
    description: 'Formação em aconselhamento cristão e pastoral com apostila completa, mentoria personalizada e certificação.',
    duration: 'Formação Completa',
    modality: 'Presencial e Online',
    icon: 'ri-group-line',
    features: ['Apostila Completa', 'Certificação', 'Mentoria'],
    image: 'https://readdy.ai/api/search-image?query=Christian%20pastoral%20counseling%20session%2C%20peaceful%20office%20with%20bible%20and%20notepad%2C%20compassionate%20listening%20and%20guidance%2C%20soft%20natural%20lighting%2C%20professional%20ministry%20setting%20with%20simple%20clean%20background%20emphasizing%20spiritual%20care&width=600&height=400&seq=icmi-course-counseling-001&orientation=landscape'
  },
  {
    id: 6,
    title: 'Curso Completo sobre a Bíblia',
    description: 'Um ano completo de estudos bíblicos aprofundados, do Gênesis ao Apocalipse, com material didático completo.',
    duration: '1 Ano de Estudos',
    modality: 'Presencial e Online',
    icon: 'ri-book-open-line',
    features: ['Material Completo', 'Certificação', 'Estudo Profundo'],
    image: 'https://readdy.ai/api/search-image?query=Complete%20bible%20study%20collection%20from%20Genesis%20to%20Revelation%2C%20arranged%20theological%20books%20on%20wooden%20shelf%2C%20magnifying%20glass%20examining%20scripture%20text%2C%20warm%20library%20lighting%2C%20simple%20background%20emphasizing%20comprehensive%20biblical%20knowledge&width=600&height=400&seq=icmi-course-bible-001&orientation=landscape'
  },
  {
    id: 7,
    title: 'Curso de Adoração',
    description: 'Formação completa em ministério de adoração e louvor com e-book, certificação e mentoria especializada.',
    duration: 'Programa Completo',
    modality: 'Presencial e Online',
    icon: 'ri-music-2-line',
    features: ['E-book Incluído', 'Certificação', 'Mentoria'],
    image: 'https://readdy.ai/api/search-image?query=Worship%20music%20ministry%20with%20acoustic%20guitar%20and%20open%20hymn%20book%2C%20soft%20worship%20lighting%20with%20warm%20glow%2C%20musical%20notes%20floating%20in%20peaceful%20atmosphere%2C%20simple%20clean%20background%20emphasizing%20spiritual%20worship%20and%20praise&width=600&height=400&seq=icmi-course-worship-001&orientation=landscape'
  }
];

export default function Courses() {
  return (
    <section id="cursos" className="py-24 bg-gradient-to-br from-gray-50 to-teal-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nossos Cursos
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Todos os cursos incluem apostilas completas, certificação reconhecida e estão disponíveis nas modalidades presencial e online
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {courses.map((course) => (
            <div
              key={course.id}
              className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={course.image}
                  alt={course.title}
                  className="w-full h-full object-cover object-top transition-transform duration-300 hover:scale-110"
                />
              </div>
              
              <div className="p-6">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${course.icon} text-teal-600 text-2xl`}></i>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {course.title}
                </h3>
                
                <p className="text-gray-600 mb-4 text-sm leading-relaxed">
                  {course.description}
                </p>

                <div className="space-y-2 mb-4">
                  <div className="flex items-center gap-2 text-sm text-gray-700">
                    <i className="ri-time-line text-teal-600"></i>
                    <span>{course.duration}</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-gray-700">
                    <i className="ri-global-line text-teal-600"></i>
                    <span>{course.modality}</span>
                  </div>
                </div>

                <div className="flex flex-wrap gap-2 mb-4">
                  {course.features.map((feature, index) => (
                    <span
                      key={index}
                      className="bg-teal-50 text-teal-700 text-xs px-3 py-1 rounded-full font-medium"
                    >
                      {feature}
                    </span>
                  ))}
                </div>

                <a
                  href="https://wa.me/5567992870208"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full text-center bg-teal-600 text-white py-3 rounded-lg font-medium hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Saiba Mais
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
